"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecorderInfo = exports.MediaRecorderConfiguration = exports.RecorderReasonCode = exports.RecorderState = exports.MediaRecorderStreamType = exports.MediaRecorderContainerFormat = exports.EXTERNAL_VIDEO_SOURCE_TYPE = exports.VIDEO_FRAME_PROCESS_MODE = exports.UserAudioSpectrumInfo = exports.AudioSpectrumData = exports.AudioParams = exports.AUDIO_FRAME_POSITION = exports.AudioFrame = exports.AUDIO_FRAME_TYPE = exports.SnapshotConfig = exports.VIDEO_MODULE_POSITION = exports.MEDIA_PLAYER_SOURCE_TYPE = exports.VideoFrame = exports.ExternalVideoFrame = exports.VIDEO_BUFFER_TYPE = exports.EGL_CONTEXT_TYPE = exports.ALPHA_STITCH_MODE = exports.Hdr10MetadataInfo = exports.ColorSpace = exports.TransferID = exports.MatrixID = exports.RangeID = exports.PrimaryID = exports.META_INFO_KEY = exports.CAMERA_VIDEO_SOURCE_TYPE = exports.RENDER_MODE_TYPE = exports.VIDEO_PIXEL_FORMAT = exports.AUDIO_DUAL_MONO_MODE = exports.AudioPcmFrame = exports.AudioEncodedFrameInfo = exports.PacketOptions = exports.ContentInspectConfig = exports.ContentInspectModule = exports.CONTENT_INSPECT_TYPE = exports.CONTENT_INSPECT_RESULT = exports.MEDIA_SOURCE_TYPE = exports.RAW_AUDIO_FRAME_OP_MODE_TYPE = exports.AudioParameters = exports.BYTES_PER_SAMPLE = exports.AudioRoute = exports.AUDIO_SOURCE_TYPE = exports.VIDEO_SOURCE_TYPE = exports.ExtensionContext = void 0;
class ExtensionContext {
}
exports.ExtensionContext = ExtensionContext;
var VIDEO_SOURCE_TYPE;
(function (VIDEO_SOURCE_TYPE) {
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_CAMERA_PRIMARY"] = 0] = "VIDEO_SOURCE_CAMERA_PRIMARY";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_CAMERA"] = 0] = "VIDEO_SOURCE_CAMERA";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_CAMERA_SECONDARY"] = 1] = "VIDEO_SOURCE_CAMERA_SECONDARY";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_SCREEN_PRIMARY"] = 2] = "VIDEO_SOURCE_SCREEN_PRIMARY";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_SCREEN"] = 2] = "VIDEO_SOURCE_SCREEN";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_SCREEN_SECONDARY"] = 3] = "VIDEO_SOURCE_SCREEN_SECONDARY";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_CUSTOM"] = 4] = "VIDEO_SOURCE_CUSTOM";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_MEDIA_PLAYER"] = 5] = "VIDEO_SOURCE_MEDIA_PLAYER";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_RTC_IMAGE_PNG"] = 6] = "VIDEO_SOURCE_RTC_IMAGE_PNG";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_RTC_IMAGE_JPEG"] = 7] = "VIDEO_SOURCE_RTC_IMAGE_JPEG";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_RTC_IMAGE_GIF"] = 8] = "VIDEO_SOURCE_RTC_IMAGE_GIF";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_REMOTE"] = 9] = "VIDEO_SOURCE_REMOTE";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_TRANSCODED"] = 10] = "VIDEO_SOURCE_TRANSCODED";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_CAMERA_THIRD"] = 11] = "VIDEO_SOURCE_CAMERA_THIRD";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_CAMERA_FOURTH"] = 12] = "VIDEO_SOURCE_CAMERA_FOURTH";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_SCREEN_THIRD"] = 13] = "VIDEO_SOURCE_SCREEN_THIRD";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_SCREEN_FOURTH"] = 14] = "VIDEO_SOURCE_SCREEN_FOURTH";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_SPEECH_DRIVEN"] = 15] = "VIDEO_SOURCE_SPEECH_DRIVEN";
    VIDEO_SOURCE_TYPE[VIDEO_SOURCE_TYPE["VIDEO_SOURCE_UNKNOWN"] = 100] = "VIDEO_SOURCE_UNKNOWN";
})(VIDEO_SOURCE_TYPE || (exports.VIDEO_SOURCE_TYPE = VIDEO_SOURCE_TYPE = {}));
var AUDIO_SOURCE_TYPE;
(function (AUDIO_SOURCE_TYPE) {
    AUDIO_SOURCE_TYPE[AUDIO_SOURCE_TYPE["AUDIO_SOURCE_MICROPHONE"] = 0] = "AUDIO_SOURCE_MICROPHONE";
    AUDIO_SOURCE_TYPE[AUDIO_SOURCE_TYPE["AUDIO_SOURCE_CUSTOM"] = 1] = "AUDIO_SOURCE_CUSTOM";
    AUDIO_SOURCE_TYPE[AUDIO_SOURCE_TYPE["AUDIO_SOURCE_MEDIA_PLAYER"] = 2] = "AUDIO_SOURCE_MEDIA_PLAYER";
    AUDIO_SOURCE_TYPE[AUDIO_SOURCE_TYPE["AUDIO_SOURCE_LOOPBACK_RECORDING"] = 3] = "AUDIO_SOURCE_LOOPBACK_RECORDING";
    AUDIO_SOURCE_TYPE[AUDIO_SOURCE_TYPE["AUDIO_SOURCE_MIXED_STREAM"] = 4] = "AUDIO_SOURCE_MIXED_STREAM";
    AUDIO_SOURCE_TYPE[AUDIO_SOURCE_TYPE["AUDIO_SOURCE_REMOTE_USER"] = 5] = "AUDIO_SOURCE_REMOTE_USER";
    AUDIO_SOURCE_TYPE[AUDIO_SOURCE_TYPE["AUDIO_SOURCE_REMOTE_CHANNEL"] = 6] = "AUDIO_SOURCE_REMOTE_CHANNEL";
    AUDIO_SOURCE_TYPE[AUDIO_SOURCE_TYPE["AUDIO_SOURCE_UNKNOWN"] = 100] = "AUDIO_SOURCE_UNKNOWN";
})(AUDIO_SOURCE_TYPE || (exports.AUDIO_SOURCE_TYPE = AUDIO_SOURCE_TYPE = {}));
var AudioRoute;
(function (AudioRoute) {
    AudioRoute[AudioRoute["ROUTE_DEFAULT"] = -1] = "ROUTE_DEFAULT";
    AudioRoute[AudioRoute["ROUTE_HEADSET"] = 0] = "ROUTE_HEADSET";
    AudioRoute[AudioRoute["ROUTE_EARPIECE"] = 1] = "ROUTE_EARPIECE";
    AudioRoute[AudioRoute["ROUTE_HEADSETNOMIC"] = 2] = "ROUTE_HEADSETNOMIC";
    AudioRoute[AudioRoute["ROUTE_SPEAKERPHONE"] = 3] = "ROUTE_SPEAKERPHONE";
    AudioRoute[AudioRoute["ROUTE_LOUDSPEAKER"] = 4] = "ROUTE_LOUDSPEAKER";
    AudioRoute[AudioRoute["ROUTE_BLUETOOTH_DEVICE_HFP"] = 5] = "ROUTE_BLUETOOTH_DEVICE_HFP";
    AudioRoute[AudioRoute["ROUTE_USB"] = 6] = "ROUTE_USB";
    AudioRoute[AudioRoute["ROUTE_HDMI"] = 7] = "ROUTE_HDMI";
    AudioRoute[AudioRoute["ROUTE_DISPLAYPORT"] = 8] = "ROUTE_DISPLAYPORT";
    AudioRoute[AudioRoute["ROUTE_AIRPLAY"] = 9] = "ROUTE_AIRPLAY";
    AudioRoute[AudioRoute["ROUTE_BLUETOOTH_DEVICE_A2DP"] = 10] = "ROUTE_BLUETOOTH_DEVICE_A2DP";
})(AudioRoute || (exports.AudioRoute = AudioRoute = {}));
var BYTES_PER_SAMPLE;
(function (BYTES_PER_SAMPLE) {
    BYTES_PER_SAMPLE[BYTES_PER_SAMPLE["TWO_BYTES_PER_SAMPLE"] = 2] = "TWO_BYTES_PER_SAMPLE";
})(BYTES_PER_SAMPLE || (exports.BYTES_PER_SAMPLE = BYTES_PER_SAMPLE = {}));
class AudioParameters {
}
exports.AudioParameters = AudioParameters;
var RAW_AUDIO_FRAME_OP_MODE_TYPE;
(function (RAW_AUDIO_FRAME_OP_MODE_TYPE) {
    RAW_AUDIO_FRAME_OP_MODE_TYPE[RAW_AUDIO_FRAME_OP_MODE_TYPE["RAW_AUDIO_FRAME_OP_MODE_READ_ONLY"] = 0] = "RAW_AUDIO_FRAME_OP_MODE_READ_ONLY";
    RAW_AUDIO_FRAME_OP_MODE_TYPE[RAW_AUDIO_FRAME_OP_MODE_TYPE["RAW_AUDIO_FRAME_OP_MODE_READ_WRITE"] = 2] = "RAW_AUDIO_FRAME_OP_MODE_READ_WRITE";
})(RAW_AUDIO_FRAME_OP_MODE_TYPE || (exports.RAW_AUDIO_FRAME_OP_MODE_TYPE = RAW_AUDIO_FRAME_OP_MODE_TYPE = {}));
var MEDIA_SOURCE_TYPE;
(function (MEDIA_SOURCE_TYPE) {
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["AUDIO_PLAYOUT_SOURCE"] = 0] = "AUDIO_PLAYOUT_SOURCE";
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["AUDIO_RECORDING_SOURCE"] = 1] = "AUDIO_RECORDING_SOURCE";
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["PRIMARY_CAMERA_SOURCE"] = 2] = "PRIMARY_CAMERA_SOURCE";
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["SECONDARY_CAMERA_SOURCE"] = 3] = "SECONDARY_CAMERA_SOURCE";
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["PRIMARY_SCREEN_SOURCE"] = 4] = "PRIMARY_SCREEN_SOURCE";
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["SECONDARY_SCREEN_SOURCE"] = 5] = "SECONDARY_SCREEN_SOURCE";
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["CUSTOM_VIDEO_SOURCE"] = 6] = "CUSTOM_VIDEO_SOURCE";
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["MEDIA_PLAYER_SOURCE"] = 7] = "MEDIA_PLAYER_SOURCE";
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["RTC_IMAGE_PNG_SOURCE"] = 8] = "RTC_IMAGE_PNG_SOURCE";
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["RTC_IMAGE_JPEG_SOURCE"] = 9] = "RTC_IMAGE_JPEG_SOURCE";
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["RTC_IMAGE_GIF_SOURCE"] = 10] = "RTC_IMAGE_GIF_SOURCE";
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["REMOTE_VIDEO_SOURCE"] = 11] = "REMOTE_VIDEO_SOURCE";
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["TRANSCODED_VIDEO_SOURCE"] = 12] = "TRANSCODED_VIDEO_SOURCE";
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["SPEECH_DRIVEN_VIDEO_SOURCE"] = 13] = "SPEECH_DRIVEN_VIDEO_SOURCE";
    MEDIA_SOURCE_TYPE[MEDIA_SOURCE_TYPE["UNKNOWN_MEDIA_SOURCE"] = 100] = "UNKNOWN_MEDIA_SOURCE";
})(MEDIA_SOURCE_TYPE || (exports.MEDIA_SOURCE_TYPE = MEDIA_SOURCE_TYPE = {}));
var CONTENT_INSPECT_RESULT;
(function (CONTENT_INSPECT_RESULT) {
    CONTENT_INSPECT_RESULT[CONTENT_INSPECT_RESULT["CONTENT_INSPECT_NEUTRAL"] = 1] = "CONTENT_INSPECT_NEUTRAL";
    CONTENT_INSPECT_RESULT[CONTENT_INSPECT_RESULT["CONTENT_INSPECT_SEXY"] = 2] = "CONTENT_INSPECT_SEXY";
    CONTENT_INSPECT_RESULT[CONTENT_INSPECT_RESULT["CONTENT_INSPECT_PORN"] = 3] = "CONTENT_INSPECT_PORN";
})(CONTENT_INSPECT_RESULT || (exports.CONTENT_INSPECT_RESULT = CONTENT_INSPECT_RESULT = {}));
var CONTENT_INSPECT_TYPE;
(function (CONTENT_INSPECT_TYPE) {
    CONTENT_INSPECT_TYPE[CONTENT_INSPECT_TYPE["CONTENT_INSPECT_INVALID"] = 0] = "CONTENT_INSPECT_INVALID";
    CONTENT_INSPECT_TYPE[CONTENT_INSPECT_TYPE["CONTENT_INSPECT_MODERATION"] = 1] = "CONTENT_INSPECT_MODERATION";
    CONTENT_INSPECT_TYPE[CONTENT_INSPECT_TYPE["CONTENT_INSPECT_SUPERVISION"] = 2] = "CONTENT_INSPECT_SUPERVISION";
    CONTENT_INSPECT_TYPE[CONTENT_INSPECT_TYPE["CONTENT_INSPECT_IMAGE_MODERATION"] = 3] = "CONTENT_INSPECT_IMAGE_MODERATION";
})(CONTENT_INSPECT_TYPE || (exports.CONTENT_INSPECT_TYPE = CONTENT_INSPECT_TYPE = {}));
class ContentInspectModule {
}
exports.ContentInspectModule = ContentInspectModule;
class ContentInspectConfig {
}
exports.ContentInspectConfig = ContentInspectConfig;
class PacketOptions {
}
exports.PacketOptions = PacketOptions;
class AudioEncodedFrameInfo {
}
exports.AudioEncodedFrameInfo = AudioEncodedFrameInfo;
class AudioPcmFrame {
}
exports.AudioPcmFrame = AudioPcmFrame;
var AUDIO_DUAL_MONO_MODE;
(function (AUDIO_DUAL_MONO_MODE) {
    AUDIO_DUAL_MONO_MODE[AUDIO_DUAL_MONO_MODE["AUDIO_DUAL_MONO_STEREO"] = 0] = "AUDIO_DUAL_MONO_STEREO";
    AUDIO_DUAL_MONO_MODE[AUDIO_DUAL_MONO_MODE["AUDIO_DUAL_MONO_L"] = 1] = "AUDIO_DUAL_MONO_L";
    AUDIO_DUAL_MONO_MODE[AUDIO_DUAL_MONO_MODE["AUDIO_DUAL_MONO_R"] = 2] = "AUDIO_DUAL_MONO_R";
    AUDIO_DUAL_MONO_MODE[AUDIO_DUAL_MONO_MODE["AUDIO_DUAL_MONO_MIX"] = 3] = "AUDIO_DUAL_MONO_MIX";
})(AUDIO_DUAL_MONO_MODE || (exports.AUDIO_DUAL_MONO_MODE = AUDIO_DUAL_MONO_MODE = {}));
var VIDEO_PIXEL_FORMAT;
(function (VIDEO_PIXEL_FORMAT) {
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_PIXEL_DEFAULT"] = 0] = "VIDEO_PIXEL_DEFAULT";
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_PIXEL_I420"] = 1] = "VIDEO_PIXEL_I420";
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_PIXEL_BGRA"] = 2] = "VIDEO_PIXEL_BGRA";
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_PIXEL_NV21"] = 3] = "VIDEO_PIXEL_NV21";
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_PIXEL_RGBA"] = 4] = "VIDEO_PIXEL_RGBA";
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_PIXEL_NV12"] = 8] = "VIDEO_PIXEL_NV12";
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_TEXTURE_2D"] = 10] = "VIDEO_TEXTURE_2D";
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_TEXTURE_OES"] = 11] = "VIDEO_TEXTURE_OES";
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_CVPIXEL_NV12"] = 12] = "VIDEO_CVPIXEL_NV12";
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_CVPIXEL_I420"] = 13] = "VIDEO_CVPIXEL_I420";
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_CVPIXEL_BGRA"] = 14] = "VIDEO_CVPIXEL_BGRA";
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_CVPIXEL_P010"] = 15] = "VIDEO_CVPIXEL_P010";
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_PIXEL_I422"] = 16] = "VIDEO_PIXEL_I422";
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_TEXTURE_ID3D11TEXTURE2D"] = 17] = "VIDEO_TEXTURE_ID3D11TEXTURE2D";
    VIDEO_PIXEL_FORMAT[VIDEO_PIXEL_FORMAT["VIDEO_PIXEL_I010"] = 18] = "VIDEO_PIXEL_I010";
})(VIDEO_PIXEL_FORMAT || (exports.VIDEO_PIXEL_FORMAT = VIDEO_PIXEL_FORMAT = {}));
var RENDER_MODE_TYPE;
(function (RENDER_MODE_TYPE) {
    RENDER_MODE_TYPE[RENDER_MODE_TYPE["RENDER_MODE_HIDDEN"] = 1] = "RENDER_MODE_HIDDEN";
    RENDER_MODE_TYPE[RENDER_MODE_TYPE["RENDER_MODE_FIT"] = 2] = "RENDER_MODE_FIT";
    RENDER_MODE_TYPE[RENDER_MODE_TYPE["RENDER_MODE_ADAPTIVE"] = 3] = "RENDER_MODE_ADAPTIVE";
})(RENDER_MODE_TYPE || (exports.RENDER_MODE_TYPE = RENDER_MODE_TYPE = {}));
var CAMERA_VIDEO_SOURCE_TYPE;
(function (CAMERA_VIDEO_SOURCE_TYPE) {
    CAMERA_VIDEO_SOURCE_TYPE[CAMERA_VIDEO_SOURCE_TYPE["CAMERA_SOURCE_FRONT"] = 0] = "CAMERA_SOURCE_FRONT";
    CAMERA_VIDEO_SOURCE_TYPE[CAMERA_VIDEO_SOURCE_TYPE["CAMERA_SOURCE_BACK"] = 1] = "CAMERA_SOURCE_BACK";
    CAMERA_VIDEO_SOURCE_TYPE[CAMERA_VIDEO_SOURCE_TYPE["VIDEO_SOURCE_UNSPECIFIED"] = 2] = "VIDEO_SOURCE_UNSPECIFIED";
})(CAMERA_VIDEO_SOURCE_TYPE || (exports.CAMERA_VIDEO_SOURCE_TYPE = CAMERA_VIDEO_SOURCE_TYPE = {}));
var META_INFO_KEY;
(function (META_INFO_KEY) {
    META_INFO_KEY[META_INFO_KEY["KEY_FACE_CAPTURE"] = 0] = "KEY_FACE_CAPTURE";
})(META_INFO_KEY || (exports.META_INFO_KEY = META_INFO_KEY = {}));
var PrimaryID;
(function (PrimaryID) {
    PrimaryID[PrimaryID["PRIMARYID_BT709"] = 1] = "PRIMARYID_BT709";
    PrimaryID[PrimaryID["PRIMARYID_UNSPECIFIED"] = 2] = "PRIMARYID_UNSPECIFIED";
    PrimaryID[PrimaryID["PRIMARYID_BT470M"] = 4] = "PRIMARYID_BT470M";
    PrimaryID[PrimaryID["PRIMARYID_BT470BG"] = 5] = "PRIMARYID_BT470BG";
    PrimaryID[PrimaryID["PRIMARYID_SMPTE170M"] = 6] = "PRIMARYID_SMPTE170M";
    PrimaryID[PrimaryID["PRIMARYID_SMPTE240M"] = 7] = "PRIMARYID_SMPTE240M";
    PrimaryID[PrimaryID["PRIMARYID_FILM"] = 8] = "PRIMARYID_FILM";
    PrimaryID[PrimaryID["PRIMARYID_BT2020"] = 9] = "PRIMARYID_BT2020";
    PrimaryID[PrimaryID["PRIMARYID_SMPTEST428"] = 10] = "PRIMARYID_SMPTEST428";
    PrimaryID[PrimaryID["PRIMARYID_SMPTEST431"] = 11] = "PRIMARYID_SMPTEST431";
    PrimaryID[PrimaryID["PRIMARYID_SMPTEST432"] = 12] = "PRIMARYID_SMPTEST432";
    PrimaryID[PrimaryID["PRIMARYID_JEDECP22"] = 22] = "PRIMARYID_JEDECP22";
})(PrimaryID || (exports.PrimaryID = PrimaryID = {}));
var RangeID;
(function (RangeID) {
    RangeID[RangeID["RANGEID_INVALID"] = 0] = "RANGEID_INVALID";
    RangeID[RangeID["RANGEID_LIMITED"] = 1] = "RANGEID_LIMITED";
    RangeID[RangeID["RANGEID_FULL"] = 2] = "RANGEID_FULL";
    RangeID[RangeID["RANGEID_DERIVED"] = 3] = "RANGEID_DERIVED";
})(RangeID || (exports.RangeID = RangeID = {}));
var MatrixID;
(function (MatrixID) {
    MatrixID[MatrixID["MATRIXID_RGB"] = 0] = "MATRIXID_RGB";
    MatrixID[MatrixID["MATRIXID_BT709"] = 1] = "MATRIXID_BT709";
    MatrixID[MatrixID["MATRIXID_UNSPECIFIED"] = 2] = "MATRIXID_UNSPECIFIED";
    MatrixID[MatrixID["MATRIXID_FCC"] = 4] = "MATRIXID_FCC";
    MatrixID[MatrixID["MATRIXID_BT470BG"] = 5] = "MATRIXID_BT470BG";
    MatrixID[MatrixID["MATRIXID_SMPTE170M"] = 6] = "MATRIXID_SMPTE170M";
    MatrixID[MatrixID["MATRIXID_SMPTE240M"] = 7] = "MATRIXID_SMPTE240M";
    MatrixID[MatrixID["MATRIXID_YCOCG"] = 8] = "MATRIXID_YCOCG";
    MatrixID[MatrixID["MATRIXID_BT2020_NCL"] = 9] = "MATRIXID_BT2020_NCL";
    MatrixID[MatrixID["MATRIXID_BT2020_CL"] = 10] = "MATRIXID_BT2020_CL";
    MatrixID[MatrixID["MATRIXID_SMPTE2085"] = 11] = "MATRIXID_SMPTE2085";
    MatrixID[MatrixID["MATRIXID_CDNCLS"] = 12] = "MATRIXID_CDNCLS";
    MatrixID[MatrixID["MATRIXID_CDCLS"] = 13] = "MATRIXID_CDCLS";
    MatrixID[MatrixID["MATRIXID_BT2100_ICTCP"] = 14] = "MATRIXID_BT2100_ICTCP";
})(MatrixID || (exports.MatrixID = MatrixID = {}));
var TransferID;
(function (TransferID) {
    TransferID[TransferID["TRANSFERID_BT709"] = 1] = "TRANSFERID_BT709";
    TransferID[TransferID["TRANSFERID_UNSPECIFIED"] = 2] = "TRANSFERID_UNSPECIFIED";
    TransferID[TransferID["TRANSFERID_GAMMA22"] = 4] = "TRANSFERID_GAMMA22";
    TransferID[TransferID["TRANSFERID_GAMMA28"] = 5] = "TRANSFERID_GAMMA28";
    TransferID[TransferID["TRANSFERID_SMPTE170M"] = 6] = "TRANSFERID_SMPTE170M";
    TransferID[TransferID["TRANSFERID_SMPTE240M"] = 7] = "TRANSFERID_SMPTE240M";
    TransferID[TransferID["TRANSFERID_LINEAR"] = 8] = "TRANSFERID_LINEAR";
    TransferID[TransferID["TRANSFERID_LOG"] = 9] = "TRANSFERID_LOG";
    TransferID[TransferID["TRANSFERID_LOG_SQRT"] = 10] = "TRANSFERID_LOG_SQRT";
    TransferID[TransferID["TRANSFERID_IEC61966_2_4"] = 11] = "TRANSFERID_IEC61966_2_4";
    TransferID[TransferID["TRANSFERID_BT1361_ECG"] = 12] = "TRANSFERID_BT1361_ECG";
    TransferID[TransferID["TRANSFERID_IEC61966_2_1"] = 13] = "TRANSFERID_IEC61966_2_1";
    TransferID[TransferID["TRANSFERID_BT2020_10"] = 14] = "TRANSFERID_BT2020_10";
    TransferID[TransferID["TRANSFERID_BT2020_12"] = 15] = "TRANSFERID_BT2020_12";
    TransferID[TransferID["TRANSFERID_SMPTEST2084"] = 16] = "TRANSFERID_SMPTEST2084";
    TransferID[TransferID["TRANSFERID_SMPTEST428"] = 17] = "TRANSFERID_SMPTEST428";
    TransferID[TransferID["TRANSFERID_ARIB_STD_B67"] = 18] = "TRANSFERID_ARIB_STD_B67";
})(TransferID || (exports.TransferID = TransferID = {}));
class ColorSpace {
}
exports.ColorSpace = ColorSpace;
class Hdr10MetadataInfo {
}
exports.Hdr10MetadataInfo = Hdr10MetadataInfo;
var ALPHA_STITCH_MODE;
(function (ALPHA_STITCH_MODE) {
    ALPHA_STITCH_MODE[ALPHA_STITCH_MODE["NO_ALPHA_STITCH"] = 0] = "NO_ALPHA_STITCH";
    ALPHA_STITCH_MODE[ALPHA_STITCH_MODE["ALPHA_STITCH_UP"] = 1] = "ALPHA_STITCH_UP";
    ALPHA_STITCH_MODE[ALPHA_STITCH_MODE["ALPHA_STITCH_BELOW"] = 2] = "ALPHA_STITCH_BELOW";
    ALPHA_STITCH_MODE[ALPHA_STITCH_MODE["ALPHA_STITCH_LEFT"] = 3] = "ALPHA_STITCH_LEFT";
    ALPHA_STITCH_MODE[ALPHA_STITCH_MODE["ALPHA_STITCH_RIGHT"] = 4] = "ALPHA_STITCH_RIGHT";
})(ALPHA_STITCH_MODE || (exports.ALPHA_STITCH_MODE = ALPHA_STITCH_MODE = {}));
var EGL_CONTEXT_TYPE;
(function (EGL_CONTEXT_TYPE) {
    EGL_CONTEXT_TYPE[EGL_CONTEXT_TYPE["EGL_CONTEXT10"] = 0] = "EGL_CONTEXT10";
    EGL_CONTEXT_TYPE[EGL_CONTEXT_TYPE["EGL_CONTEXT14"] = 1] = "EGL_CONTEXT14";
})(EGL_CONTEXT_TYPE || (exports.EGL_CONTEXT_TYPE = EGL_CONTEXT_TYPE = {}));
var VIDEO_BUFFER_TYPE;
(function (VIDEO_BUFFER_TYPE) {
    VIDEO_BUFFER_TYPE[VIDEO_BUFFER_TYPE["VIDEO_BUFFER_RAW_DATA"] = 1] = "VIDEO_BUFFER_RAW_DATA";
    VIDEO_BUFFER_TYPE[VIDEO_BUFFER_TYPE["VIDEO_BUFFER_ARRAY"] = 2] = "VIDEO_BUFFER_ARRAY";
    VIDEO_BUFFER_TYPE[VIDEO_BUFFER_TYPE["VIDEO_BUFFER_TEXTURE"] = 3] = "VIDEO_BUFFER_TEXTURE";
})(VIDEO_BUFFER_TYPE || (exports.VIDEO_BUFFER_TYPE = VIDEO_BUFFER_TYPE = {}));
class ExternalVideoFrame {
}
exports.ExternalVideoFrame = ExternalVideoFrame;
class VideoFrame {
}
exports.VideoFrame = VideoFrame;
var MEDIA_PLAYER_SOURCE_TYPE;
(function (MEDIA_PLAYER_SOURCE_TYPE) {
    MEDIA_PLAYER_SOURCE_TYPE[MEDIA_PLAYER_SOURCE_TYPE["MEDIA_PLAYER_SOURCE_DEFAULT"] = 0] = "MEDIA_PLAYER_SOURCE_DEFAULT";
    MEDIA_PLAYER_SOURCE_TYPE[MEDIA_PLAYER_SOURCE_TYPE["MEDIA_PLAYER_SOURCE_FULL_FEATURED"] = 1] = "MEDIA_PLAYER_SOURCE_FULL_FEATURED";
    MEDIA_PLAYER_SOURCE_TYPE[MEDIA_PLAYER_SOURCE_TYPE["MEDIA_PLAYER_SOURCE_SIMPLE"] = 2] = "MEDIA_PLAYER_SOURCE_SIMPLE";
})(MEDIA_PLAYER_SOURCE_TYPE || (exports.MEDIA_PLAYER_SOURCE_TYPE = MEDIA_PLAYER_SOURCE_TYPE = {}));
var VIDEO_MODULE_POSITION;
(function (VIDEO_MODULE_POSITION) {
    VIDEO_MODULE_POSITION[VIDEO_MODULE_POSITION["POSITION_POST_CAPTURER"] = 1] = "POSITION_POST_CAPTURER";
    VIDEO_MODULE_POSITION[VIDEO_MODULE_POSITION["POSITION_PRE_RENDERER"] = 1] = "POSITION_PRE_RENDERER";
    VIDEO_MODULE_POSITION[VIDEO_MODULE_POSITION["POSITION_PRE_ENCODER"] = 1] = "POSITION_PRE_ENCODER";
    VIDEO_MODULE_POSITION[VIDEO_MODULE_POSITION["POSITION_POST_CAPTURER_ORIGIN"] = 1] = "POSITION_POST_CAPTURER_ORIGIN";
})(VIDEO_MODULE_POSITION || (exports.VIDEO_MODULE_POSITION = VIDEO_MODULE_POSITION = {}));
class SnapshotConfig {
}
exports.SnapshotConfig = SnapshotConfig;
var AUDIO_FRAME_TYPE;
(function (AUDIO_FRAME_TYPE) {
    AUDIO_FRAME_TYPE[AUDIO_FRAME_TYPE["FRAME_TYPE_PCM16"] = 0] = "FRAME_TYPE_PCM16";
})(AUDIO_FRAME_TYPE || (exports.AUDIO_FRAME_TYPE = AUDIO_FRAME_TYPE = {}));
class AudioFrame {
}
exports.AudioFrame = AudioFrame;
var AUDIO_FRAME_POSITION;
(function (AUDIO_FRAME_POSITION) {
    AUDIO_FRAME_POSITION[AUDIO_FRAME_POSITION["AUDIO_FRAME_POSITION_NONE"] = 0] = "AUDIO_FRAME_POSITION_NONE";
    AUDIO_FRAME_POSITION[AUDIO_FRAME_POSITION["AUDIO_FRAME_POSITION_PLAYBACK"] = 1] = "AUDIO_FRAME_POSITION_PLAYBACK";
    AUDIO_FRAME_POSITION[AUDIO_FRAME_POSITION["AUDIO_FRAME_POSITION_RECORD"] = 2] = "AUDIO_FRAME_POSITION_RECORD";
    AUDIO_FRAME_POSITION[AUDIO_FRAME_POSITION["AUDIO_FRAME_POSITION_MIXED"] = 4] = "AUDIO_FRAME_POSITION_MIXED";
    AUDIO_FRAME_POSITION[AUDIO_FRAME_POSITION["AUDIO_FRAME_POSITION_BEFORE_MIXING"] = 8] = "AUDIO_FRAME_POSITION_BEFORE_MIXING";
    AUDIO_FRAME_POSITION[AUDIO_FRAME_POSITION["AUDIO_FRAME_POSITION_EAR_MONITORING"] = 16] = "AUDIO_FRAME_POSITION_EAR_MONITORING";
})(AUDIO_FRAME_POSITION || (exports.AUDIO_FRAME_POSITION = AUDIO_FRAME_POSITION = {}));
class AudioParams {
}
exports.AudioParams = AudioParams;
class AudioSpectrumData {
}
exports.AudioSpectrumData = AudioSpectrumData;
class UserAudioSpectrumInfo {
}
exports.UserAudioSpectrumInfo = UserAudioSpectrumInfo;
var VIDEO_FRAME_PROCESS_MODE;
(function (VIDEO_FRAME_PROCESS_MODE) {
    VIDEO_FRAME_PROCESS_MODE[VIDEO_FRAME_PROCESS_MODE["PROCESS_MODE_READ_ONLY"] = 0] = "PROCESS_MODE_READ_ONLY";
    VIDEO_FRAME_PROCESS_MODE[VIDEO_FRAME_PROCESS_MODE["PROCESS_MODE_READ_WRITE"] = 1] = "PROCESS_MODE_READ_WRITE";
})(VIDEO_FRAME_PROCESS_MODE || (exports.VIDEO_FRAME_PROCESS_MODE = VIDEO_FRAME_PROCESS_MODE = {}));
var EXTERNAL_VIDEO_SOURCE_TYPE;
(function (EXTERNAL_VIDEO_SOURCE_TYPE) {
    EXTERNAL_VIDEO_SOURCE_TYPE[EXTERNAL_VIDEO_SOURCE_TYPE["VIDEO_FRAME"] = 0] = "VIDEO_FRAME";
    EXTERNAL_VIDEO_SOURCE_TYPE[EXTERNAL_VIDEO_SOURCE_TYPE["ENCODED_VIDEO_FRAME"] = 1] = "ENCODED_VIDEO_FRAME";
})(EXTERNAL_VIDEO_SOURCE_TYPE || (exports.EXTERNAL_VIDEO_SOURCE_TYPE = EXTERNAL_VIDEO_SOURCE_TYPE = {}));
var MediaRecorderContainerFormat;
(function (MediaRecorderContainerFormat) {
    MediaRecorderContainerFormat[MediaRecorderContainerFormat["FORMAT_MP4"] = 1] = "FORMAT_MP4";
})(MediaRecorderContainerFormat || (exports.MediaRecorderContainerFormat = MediaRecorderContainerFormat = {}));
var MediaRecorderStreamType;
(function (MediaRecorderStreamType) {
    MediaRecorderStreamType[MediaRecorderStreamType["STREAM_TYPE_AUDIO"] = 1] = "STREAM_TYPE_AUDIO";
    MediaRecorderStreamType[MediaRecorderStreamType["STREAM_TYPE_VIDEO"] = 2] = "STREAM_TYPE_VIDEO";
    MediaRecorderStreamType[MediaRecorderStreamType["STREAM_TYPE_BOTH"] = 3] = "STREAM_TYPE_BOTH";
})(MediaRecorderStreamType || (exports.MediaRecorderStreamType = MediaRecorderStreamType = {}));
var RecorderState;
(function (RecorderState) {
    RecorderState[RecorderState["RECORDER_STATE_ERROR"] = -1] = "RECORDER_STATE_ERROR";
    RecorderState[RecorderState["RECORDER_STATE_START"] = 2] = "RECORDER_STATE_START";
    RecorderState[RecorderState["RECORDER_STATE_STOP"] = 3] = "RECORDER_STATE_STOP";
})(RecorderState || (exports.RecorderState = RecorderState = {}));
var RecorderReasonCode;
(function (RecorderReasonCode) {
    RecorderReasonCode[RecorderReasonCode["RECORDER_REASON_NONE"] = 0] = "RECORDER_REASON_NONE";
    RecorderReasonCode[RecorderReasonCode["RECORDER_REASON_WRITE_FAILED"] = 1] = "RECORDER_REASON_WRITE_FAILED";
    RecorderReasonCode[RecorderReasonCode["RECORDER_REASON_NO_STREAM"] = 2] = "RECORDER_REASON_NO_STREAM";
    RecorderReasonCode[RecorderReasonCode["RECORDER_REASON_OVER_MAX_DURATION"] = 3] = "RECORDER_REASON_OVER_MAX_DURATION";
    RecorderReasonCode[RecorderReasonCode["RECORDER_REASON_CONFIG_CHANGED"] = 4] = "RECORDER_REASON_CONFIG_CHANGED";
})(RecorderReasonCode || (exports.RecorderReasonCode = RecorderReasonCode = {}));
class MediaRecorderConfiguration {
}
exports.MediaRecorderConfiguration = MediaRecorderConfiguration;
class RecorderInfo {
}
exports.RecorderInfo = RecorderInfo;
